<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER: Title va Kurs Sozlamalari -->
      <div class="header-row">
        <h2 class="page-title expenses-title">Xarajatlar</h2>

        <div class="header-right">
          <!-- Dollar Kursi -->
          <div class="rate-settings-container" ref="settingsContainer">
            <div class="rate-display" @click.stop="toggleSettings">
              <div class="dollar-circle">$</div>
              <span class="rate-value">{{ dollarRate | numFormat }}</span>
            </div>

            <transition name="slide-fade">
              <div v-if="showSettings" class="mini-modal" @click.stop>
                <div class="modal-arrow"></div>
                <div class="modal-body">
                  <label class="modal-title">Yangi kursni kiriting</label>
                  <input type="number" v-model.number="newRate" placeholder="12 500..."
                    @keyup.enter="updateDollarRate" />
                  <button class="modal-save-btn" @click="updateDollarRate">
                    {{ isSaving ? 'Saqlanmoqda...' : 'SAQLASH' }}
                  </button>
                </div>
              </div>
            </transition>
          </div>

          <!-- Top Menu (Agar kerak bo'lsa) -->
          <Top />
        </div>
      </div>

      <!-- FORM QISMI -->
      <div class="form-card expense-card">
        <div class="expense-form-row">

          <!-- Kategoriya Select + Edit Button -->
          <div class="input-group flex-1 d-flex gap-2">
            <div class="select-wrapper w-100">
              <select v-model="form.kassa_category_id" :class="{ 'invalid-border': errors.kassa_category_id }">
                <option :value="null" disabled>Kategoriya tanlang...</option>
                <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
              </select>
            </div>

          </div>

          <!-- To'lov turi -->
          <div class="input-group flex-1">
            <select v-model="form.pay_type_id" :class="{ 'invalid-border': errors.pay_type_id }">
              <option :value="null" disabled>To'lov turi...</option>
              <option v-for="pay in paymentTypes" :key="pay.id" :value="pay.id">{{ pay.name }}</option>
            </select>
          </div>

          <!-- Summa -->
          <div class="input-group flex-1">
            <input type="number" v-model.number="form.amount" placeholder="Summa"
              :class="{ 'invalid-border': errors.amount }" />
          </div>

          <!-- Izoh -->
          <div class="input-group flex-2">
            <input type="text" v-model="form.comment" placeholder="Izoh..." @keyup.enter="addExpense" />
          </div>

          <!-- Qo'shish tugmasi -->
          <div class="action-buttons">
            <button class="add-expense-btn" @click="addExpense" :disabled="isSubmitting">
              <span v-if="!isSubmitting">+</span>
              <span v-else class="spinner-border spinner-border-sm"></span>
            </button>
            <button class="icon-btn settings-btn" @click="openCategoryModal" title="Kategoriyalarni boshqarish">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"></circle>
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="expense-table-wrapper">
        <div class="table-scroll-container">
          <table class="expense-table">
            <thead>
              <tr>
                <th style="width: 60px">#</th>
                <th style="width: 15%">SANA</th>
                <th style="width: 20%">KATEGORIYA</th>
                <th style="width: 15%">TO'LOV TURI</th>
                <th style="width: 25%">IZOH</th>
                <th style="width: 15%">SUMMA</th>
                <th style="width: 10%; text-align: center;">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in expenses" :key="item.id">
                <td><span class="id-badge">{{ item.id }}</span></td>
                <td>{{ formatDate(item.datetime) }}</td>
                <td>
                  <span class="cat-badge">{{ getCatName(item.kassa_category_id) }}</span>
                </td>
                <td>{{ getPayName(item.pay_type_id) }}</td>
                <td class="text-muted">{{ item.comment }}</td>
                <td class="sum-text">
                  <!-- Agar dollar bo'lsa -->
                  <span v-if="item.dollar_summa > 0">
                    {{ item.dollar_summa | numFormat }} $
                  </span>
                  <!-- Agar so'm bo'lsa -->
                  <span v-else>
                    {{ item.summa | numFormat }}
                  </span>
                </td>
                <td style="text-align: center;">
                  <button class="icon-btn delete-btn" @click="deleteExpense(item.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </td>
              </tr>

              <tr v-if="expenses.length === 0">
                <td colspan="7" class="text-center py-5 text-muted">
                  Ma'lumot mavjud emas
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- CATEGORY MODAL -->
    <div v-if="showCategoryModal" class="modal-overlay" @click.self="closeCategoryModal">
      <div class="modal-box animate-pop">

        <!-- 1. Header -->
        <div class="modal-header">
          <h3 class="modal-title">Kategoriyalarni boshqarish</h3>
          <button class="close-icon-btn" @click="closeCategoryModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div class="modal-content">
          <!-- 2. Input va Qo'shish (Tepada) -->
          <div class="input-area">
            <div class="input-wrapper">
              <input type="text" v-model="newCategoryName" placeholder="Yangi kategoriya nomi..." class="modern-input"
                @keyup.enter="createCategory" ref="catInput">
            </div>
            <button class="modern-add-btn" @click="createCategory" :disabled="!newCategoryName">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Qo'shish
            </button>
          </div>

          <div class="separator-line"></div>

          <!-- 3. Ro'yxat (Pastda, alohida card) -->
          <div class="list-container-card">
            <h4 class="list-title">Mavjud kategoriyalar ({{ categories.length }})</h4>

            <div class="custom-scroll-area">
              <div v-for="cat in categories" :key="cat.id" class="cat-item-card">
                <span class="cat-name">{{ cat.name }}</span>
                <button class="cat-delete-icon" @click="deleteCategory(cat.id)" title="O'chirish">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>

              <!-- Bo'sh holat -->
              <div v-if="categories.length === 0" class="empty-state">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"
                  stroke="#cbd5e1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <p>Hozircha kategoriyalar yo'q</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';

export default {
  name: 'KassaOrder',
  components: { Top },
  data() {
    return {
      // Data
      dollarRate: 0,
      newRate: null,
      showSettings: false,
      isSaving: false,
      isSubmitting: false,

      // Category Modal
      showCategoryModal: false,
      newCategoryName: '',

      user_id: null,
      sklad_id: null,

      categories: [],
      paymentTypes: [],
      expenses: [],

      form: {
        kassa_category_id: null,
        pay_type_id: null,
        amount: null,
        comment: ""
      },
      errors: {}
    };
  },
  filters: {
    numFormat(val) {
      return val ? Number(val).toLocaleString().replace(/,/g, ' ') : "0";
    }
  },
  async mounted() {
    this.user_id = localStorage.getItem('user_id');
    this.sklad_id = localStorage.getItem('sklad_id');

    await this.fetchInitialData();
    await this.fetchExpenses(); // Tarixni yuklash

    window.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    // 1. MA'LUMOTLARNI YUKLASH
    async fetchInitialData() {
      try {
        const [rateRes, catRes, payRes] = await Promise.all([
          axios.get('/api/v1/dollar-exchange-rate/last'),
          axios.get('/api/v1/kassa-category'),
          axios.get('/api/v1/pay-type')
        ]);

        this.dollarRate = rateRes.data.rate || rateRes.data.amount || 0;
        this.categories = catRes.data.data || catRes.data; // API tuzilishiga qarab
        this.paymentTypes = payRes.data;

      } catch (e) {
        console.error("Init data error:", e);
      }
    },

    async fetchExpenses() {
      try {
        // Hozircha hammasini olib keladi. Keyinchalik page/limit qo'shish mumkin
        const res = await axios.get('/api/v1/kassa-order');
        // Backenddan kelgan ma'lumot array ekanligiga ishonch hosil qilamiz
        this.expenses = Array.isArray(res.data) ? res.data : (res.data.data || []);
      } catch (e) {
        console.error("Expenses fetch error:", e);
      }
    },

    // 2. KURS YANGILASH
    async updateDollarRate() {
      if (!this.newRate || this.isSaving) return;
      this.isSaving = true;
      try {
        await axios.post('/api/v1/dollar-exchange-rate', {
          rate: this.newRate,
          user_id: this.user_id,
          sklad_id: this.sklad_id,
          datetime: Math.floor(Date.now() / 1000)
        });
        this.dollarRate = this.newRate;
        this.showSettings = false;
        this.newRate = null;
      } catch (e) {
        alert("Kursni saqlashda xatolik");
      } finally {
        this.isSaving = false;
      }
    },

    // 3. XARAJAT QO'SHISH (CREATE)
    async addExpense() {
      if (!this.validate()) return;
      this.isSubmitting = true;

      const isDollar = (this.form.pay_type_id === 3); // 3-ID dollar deb faraz qilamiz

      const payload = {
        datetime: Math.floor(Date.now() / 1000),
        sklad_id: Number(this.sklad_id),
        user_id: Number(this.user_id),
        kassa_category_id: this.form.kassa_category_id,
        pay_type_id: this.form.pay_type_id,
        summa: isDollar ? 0 : this.form.amount,
        dollar_summa: isDollar ? this.form.amount : 0,
        dollar_rate: this.dollarRate,
        comment: this.form.comment
      };

      try {
        const res = await axios.post('/api/v1/kassa-order', payload);

        // Muvaffaqiyatli
        this.resetForm();
        this.fetchExpenses(); // Jadvalni yangilash

      } catch (e) {
        alert("Saqlashda xatolik: " + (e.response?.data?.message || e.message));
      } finally {
        this.isSubmitting = false;
      }
    },

    // 4. XARAJAT O'CHIRISH (DELETE)
    async deleteExpense(id) {
      if (!confirm("Haqiqatan ham bu xarajatni o'chirmoqchimisiz?")) return;
      try {
        await axios.delete(`/api/v1/kassa-order/id/${id}`);
        this.expenses = this.expenses.filter(item => item.id !== id);
      } catch (e) {
        alert("O'chirishda xatolik");
      }
    },

    // 5. KATEGORIYA CRUD (MODAL)
    openCategoryModal() { this.showCategoryModal = true; },
    closeCategoryModal() { this.showCategoryModal = false; this.newCategoryName = ''; },

    async createCategory() {
      if (!this.newCategoryName.trim()) return;
      try {
        const res = await axios.post('/api/v1/kassa-category', { name: this.newCategoryName });
        // Yangi kategoriyani ro'yxatga qo'shamiz
        const newCat = res.data.data || res.data;
        this.categories.push(newCat);
        this.newCategoryName = '';
      } catch (e) {
        alert("Kategoriya yaratishda xato: " + e.message);
      }
    },

    async deleteCategory(id) {
      if (!confirm("Kategoriyani o'chirasizmi?")) return;
      try {
        await axios.delete(`/api/v1/kassa-category/${id}`);
        this.categories = this.categories.filter(c => c.id !== id);
        // Agar formda tanlangan bo'lsa reset qilamiz
        if (this.form.kassa_category_id === id) this.form.kassa_category_id = null;
      } catch (e) {
        alert("O'chirish mumkin emas (ehtimol ishlatilgandir)");
      }
    },

    // YORDAMCHI FUNKSIYALAR
    validate() {
      this.errors = {};
      if (!this.form.kassa_category_id) this.errors.kassa_category_id = true;
      if (!this.form.pay_type_id) this.errors.pay_type_id = true;
      if (!this.form.amount || this.form.amount <= 0) this.errors.amount = true;
      return Object.keys(this.errors).length === 0;
    },
    resetForm() {
      this.form = { kassa_category_id: null, pay_type_id: null, amount: null, comment: "" };
      this.errors = {};
    },
    getCatName(id) {
      const found = this.categories.find(c => c.id === id);
      return found ? found.name : '-';
    },
    getPayName(id) {
      const found = this.paymentTypes.find(p => p.id === id);
      return found ? found.name : '-';
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      return this.$formatDate(timestamp);
    },
    toggleSettings() { this.showSettings = !this.showSettings; if (this.showSettings) this.newRate = null; },
    handleOutsideClick(event) {
      if (this.showSettings && this.$refs.settingsContainer && !this.$refs.settingsContainer.contains(event.target)) {
        this.showSettings = false;
      }
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

.action-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.g-page {
  padding: 30px;
  background-color: #f8fafc;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
  color: #334155;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.expenses-title {
  color: #be185d;
  /* Pink-700 */
  font-weight: 800;
  font-size: 28px;
  margin: 0;
  letter-spacing: -0.5px;
}

/* RATE BOX */
.rate-settings-container {
  position: relative;
}

.rate-display {
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  padding: 8px 16px 8px 10px;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}

.rate-display:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.dollar-circle {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #fbcfe8 0%, #f472b6 100%);
  color: #831843;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 16px;
}

.rate-value {
  font-size: 18px;
  color: #1e293b;
  font-weight: 700;
}

/* MINI MODAL (Rate) */
.mini-modal {
  position: absolute;
  top: 60px;
  right: 0;
  width: 260px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 20px;
  z-index: 100;
  border: 1px solid #f1f5f9;
}

.modal-arrow {
  position: absolute;
  top: -6px;
  right: 25px;
  width: 12px;
  height: 12px;
  background: white;
  transform: rotate(45deg);
  border-left: 1px solid #f1f5f9;
  border-top: 1px solid #f1f5f9;
}

/* --- MODAL ASOSIY --- */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(15, 23, 42, 0.6); /* To'qroq fon */
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-box {
  background: white;
  width: 450px; /* Biroz kattalashtirdik */
  max-width: 90%;
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Animatsiya */
.animate-pop {
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@keyframes popIn {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* --- HEADER --- */
.modal-header {
  padding: 20px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
}
.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}
.close-icon-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
  transition: 0.2s;
  display: flex;
}
.close-icon-btn:hover {
  background: #f1f5f9;
  color: #ef4444;
}

.modal-content {
  padding: 25px;
}

/* --- INPUT QISMI --- */
.input-area {
  display: flex;
  gap: 12px;
  align-items: center;
}
.input-wrapper {
  flex-grow: 1;
}
.modern-input {
  width: 100%;
  height: 48px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 15px;
  font-size: 15px;
  font-weight: 500;
  transition: 0.2s;
  outline: none;
}
.modern-input:focus {
  border-color: #be185d;
  box-shadow: 0 0 0 4px rgba(190, 24, 93, 0.1);
}
.modern-add-btn {
  height: 48px;
  padding: 0 20px;
  background: #be185d;
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.2s;
  box-shadow: 0 4px 6px rgba(190, 24, 93, 0.2);
}
.modern-add-btn:hover { background: #9d174d; transform: translateY(-1px); }
.modern-add-btn:active { transform: translateY(0); }
.modern-add-btn:disabled { background: #cbd5e1; cursor: not-allowed; box-shadow: none; }

/* CHIZIQ */
.separator-line {
  height: 1px;
  background: #f1f5f9;
  margin: 20px 0;
}

/* --- RO'YXAT (LIST) CONTAINER --- */
.list-container-card {
  background: #f8fafc; /* Kulrang fon */
  border-radius: 16px;
  padding: 15px;
  border: 1px solid #f1f5f9;
}
.list-title {
  font-size: 12px;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 700;
  margin: 0 0 10px 5px;
  letter-spacing: 0.5px;
}

.custom-scroll-area {
  max-height: 250px;
  overflow-y: auto;
  padding-right: 5px; /* Scroll uchun joy */
}

/* ITEM CARD */
.cat-item-card {
  background: white;
  border-radius: 10px;
  padding: 12px 15px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  border: 1px solid transparent;
  transition: 0.2s;
}
.cat-item-card:hover {
  border-color: #e2e8f0;
  transform: translateX(2px);
}
.cat-name {
  font-weight: 600;
  color: #334155;
  font-size: 15px;
}

/* DELETE BUTTON */
.cat-delete-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #fff1f2;
  color: #e11d48;
  border-radius: 8px;
  cursor: pointer;
  opacity: 0.8;
  transition: 0.2s;
}
.cat-delete-icon:hover {
  opacity: 1;
  background: #e11d48;
  color: white;
}

/* EMPTY STATE */
.empty-state {
  text-align: center;
  padding: 30px 0;
  color: #94a3b8;
}
.empty-state p { margin-top: 10px; font-size: 14px; }

/* SCROLLBAR STYLE */
.custom-scroll-area::-webkit-scrollbar {
  width: 5px;
}
.custom-scroll-area::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scroll-area::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.custom-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
/* EXPENSE FORM CARD */
.expense-card {
  background: white;
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  margin-bottom: 25px;
  border: 1px solid #f1f5f9;
}

.expense-form-row {
  display: flex;
  gap: 15px;
  align-items: center;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.input-group select,
.input-group input {
  width: 100%;
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 15px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  background-color: #fff;
  outline: none;
  transition: all 0.2s;
}

.input-group select:focus,
.input-group input:focus {
  border-color: #be185d;
  box-shadow: 0 0 0 3px rgba(190, 24, 93, 0.1);
}

.invalid-border {
  border-color: #ef4444 !important;
}

/* Settings Button (Category) */
.settings-btn {
  background: #f1f5f9;
  color: #64748b;
  width: 50px;
  /* Kvadrat bo'lishi uchun */
  height: 50px;
  border-radius: 12px;
}

.settings-btn:hover {
  background: #e2e8f0;
  color: #334155;
}

/* Add Button */
.add-expense-btn {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #be185d 0%, #9d174d 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(190, 24, 93, 0.3);
  transition: transform 0.1s;
}

.add-expense-btn:active {
  transform: scale(0.95);
}

.add-expense-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* TABLE */
.expense-table-wrapper {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.table-scroll-container {
  max-height: 500px;
  overflow-y: auto;
}

.expense-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.expense-table th {
  position: sticky;
  top: 0;
  background-color: #fff;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 18px 15px;
  border-bottom: 2px solid #f1f5f9;
  z-index: 5;
}

.expense-table td {
  padding: 16px 15px;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}

.id-badge {
  background: #f1f5f9;
  color: #64748b;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
}

.cat-badge {
  background: #fce7f3;
  color: #9d174d;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}

.sum-text {
  color: #be185d;
  font-weight: 700;
  font-size: 15px;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.delete-btn {
  background: #fff1f2;
  color: #e11d48;
}

.delete-btn:hover {
  background: #e11d48;
  color: white;
}

/* CATEGORY MODAL STYLES */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-box {
  background: white;
  width: 400px;
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes modalPop {
  from {
    transform: scale(0.9);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1e293b;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #94a3b8;
  cursor: pointer;
}

.add-cat-row {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.cat-input {
  flex: 1;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
}

.cat-add-btn {
  background: #be185d;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 0 15px;
  font-weight: 600;
  cursor: pointer;
}

.cat-add-btn:disabled {
  opacity: 0.5;
}

.cat-list {
  max-height: 300px;
  overflow-y: auto;
}

.cat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f1f5f9;
}

.cat-del-btn {
  background: none;
  border: none;
  color: #cbd5e1;
  cursor: pointer;
  transition: color 0.2s;
}

.cat-del-btn:hover {
  color: #ef4444;
}

/* TRANSITIONS */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.d-flex {
  display: flex;
}

.gap-2 {
  gap: 8px;
}

.w-100 {
  width: 100%;
}
</style>